<template>
  <main class="resources">
    <div class="container">
      <secondary-page/>
    </div>
  </main>
</template>

<script>
import SecondaryPage from "@/components/additional-modules/SecondaryPage";

export default {
  name: 'Resources',
  components: {
    SecondaryPage
  }
}
</script>